module.exports = __webpack_public_path__ + "static/search-for-ac29a067cf546764638d7f5929800dca.png";